import { TranslateLoader } from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { VersionService } from '../services';

export class CustomLoader implements TranslateLoader {
    private appVersion: string;

    constructor(private http: HttpClient, private versionService: VersionService) {
        this.appVersion = this.versionService.getAppVersion();
    }

    getTranslation(language: string): Observable<any> {
        return this.http.get('/assets/i18n/' + language + `.json?cacheBuster=${this.appVersion}`);
    }
}
